if (!customElements.get('dd-pdp-faq-offer')) {
  customElements.define('dd-pdp-faq-offer', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-dd-offer-content]');
      this.offers = Array.from(this.querySelectorAll('template[data-dd-offer-product-id]'));
      this.requestId = 0;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          window.clearTimeout(this.refreshTimer);
          const confirming = this.content.querySelector('.dd-card-quick-add.is-adding, .dd-card-quick-add.is-added');
          this.refreshTimer = window.setTimeout(() => this.refresh(), confirming ? 1700 : 0);
        });
      }
      this.refresh();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.clearTimeout(this.refreshTimer);
      this.requestId += 1;
    }
    update(cart) {
      if (!Array.isArray(cart.items)) return;
      const productIds = new Set(cart.items.map(item => String(item.product_id)));
      const next = this.offers.find(offer => !productIds.has(offer.dataset.ddOfferProductId));
      if (!next) {
        this.hidden = true;
        return;
      }
      if (this.dataset.activeProductId !== next.dataset.ddOfferProductId) {
        this.content.replaceChildren(next.content.cloneNode(true));
        this.dataset.activeProductId = next.dataset.ddOfferProductId;
      }
      this.hidden = false;
    }
    async refresh() {
      const requestId = ++this.requestId;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (requestId === this.requestId && this.isConnected) this.update(cart);
      } catch (_) {}
    }
  });
}
